import { api } from "./api";

const TOKEN_KEY = "token";
const USER_KEY = "usuario";

export const login = async (loginStr, senha) => {
  const { data } = await api.post("/auth/login", { Login: loginStr, Senha: senha });
  localStorage.setItem(TOKEN_KEY, data.token);
  localStorage.setItem(USER_KEY, JSON.stringify(data.usuario));
  return data;
};

// Primeiro acesso: define a senha inicial (só funciona em instalação nova).
export const bootstrap = (loginStr, senha) =>
  api.post("/auth/bootstrap", { Login: loginStr, Senha: senha });

export const alterarSenha = (senhaAtual, novaSenha) =>
  api.post("/auth/alterar-senha", { SenhaAtual: senhaAtual, NovaSenha: novaSenha });

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  window.location.href = "/login";
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const isAutenticado = () => !!getToken();
export const getUsuario = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || "null");
  } catch {
    return null;
  }
};
export const isAdmin = () => !!getUsuario()?.Admin;

// Atualiza os dados do usuário logado (ex.: flag Admin) a partir do backend.
export const refreshUsuario = async () => {
  try {
    const { data } = await api.get("/auth/me");
    localStorage.setItem(USER_KEY, JSON.stringify(data));
    return data;
  } catch {
    return getUsuario();
  }
};
